import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import AccountPage from './pages/AccountPage';
import EditorPage from './pages/EditorPage';
import PostListPage from './pages/PostListPage';
import ImageGalleryPage from './pages/ImageGalleryPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import ApiKeysPage from './pages/ApiKeysPage';
import AiAgentPage from './pages/AiAgentPage';
import AiAgentDemoPage from './pages/AiAgentDemoPage';
import AuthComponent from './components/SignIn';
import SocialCallback from './components/SocialCallback';
import LandingPage from './pages/LandingPage';
import TeamPage from './pages/TeamPage';
import { LogOut } from 'lucide-react';


function App() {
  const [user, setUser] = useState(null);

  const handleAuthSuccess = (data) => {
    setUser(data.user);
    localStorage.setItem('sessionId', data.sessionId);
    localStorage.setItem('user', JSON.stringify(data.user));
    window.location.href = "/accounts";
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('sessionId');
    localStorage.removeItem('user');
  };

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user)
      setUser(JSON.parse(user));
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/team" element={<TeamPage />} />

        <Route path="/*" element={
          <div className="flex h-screen bg-gray-50">
            <nav className="w-20 md:w-64 bg-white border-r flex flex-col p-6 shadow-sm">
              <div className="text-2xl font-black text-red-600 mb-10 tracking-tighter text-center md:text-left">
                <span className="md:hidden">AS</span>
                <span className="hidden md:inline">Antares Social</span>
              </div>
              <div className="space-y-2 flex-1">
                {[
                  { to: "/accounts", label: "Accounts", icon: "📂" },
                  { to: "/editor", label: "Create Post", icon: "✍️" },
                  { to: "/posts", label: "History", icon: "📊" },
                  { to: "/images", label: "Media", icon: "🖼️" },
                  { to: "/ai-agent", label: "AI Agent", icon: "✨" },
                  { to: "/api-keys", label: "API Keys", icon: "🔑" },
                  { to: "/profile", label: "Profile", icon: "👤" },
                  { to: "/subscription", label: "Billing", icon: "💳" },
                ].map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="flex items-center justify-center md:justify-start px-0 md:px-4 py-3 rounded-xl hover:bg-red-50 text-gray-700 font-medium transition"
                  >
                    <span className="text-xl shrink-0">{link.icon}</span>
                    <span className="hidden md:inline ml-3 truncate">{link.label}</span>
                  </Link>
                ))}
              </div>

              <div className="pt-6 border-t">
                {user ? (
                  <div className="flex flex-col gap-2">
                    <Link to="/profile" className="flex items-center justify-center md:justify-start p-2 md:px-3 md:py-2 bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                      <div className="w-8 h-8 shrink-0 rounded-full bg-red-500 flex items-center justify-center text-white text-xs font-bold uppercase">
                        {user.email[0]}
                      </div>
                      <div className="hidden md:block ml-3 flex-1 min-w-0">
                        <p className="text-xs font-bold text-gray-800 truncate">{user.email}</p>
                        <p className="text-[10px] text-green-500 font-medium">Online</p>
                      </div>
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="flex items-center justify-center md:justify-start px-3 py-2 text-sm text-gray-500 hover:text-red-500 transition"
                    >
                      <span className="md:hidden"><LogOut /></span>
                      <span className="hidden md:inline">Logout</span>
                    </button>
                  </div>
                ) : (
                  <Link
                    to="/signin"
                    className="flex items-center justify-center w-full py-3 bg-red-600 text-white rounded-xl font-bold hover:bg-red-700 shadow-md shadow-red-200 transition"
                  >
                    <span className="md:hidden">🔑</span>
                    <span className="hidden md:inline">LogIn</span>
                  </Link>
                )}
              </div>
            </nav>

            <main className="flex-1 overflow-y-auto">
              <Routes>
                <Route path="/accounts" element={<AccountPage />} />
                <Route path="/editor/:id?" element={<EditorPage />} />
                <Route path="/posts" element={<PostListPage />} />
                <Route path="/images" element={<ImageGalleryPage />} />
                <Route path="/ai-agent" element={<AiAgentPage />} />
                <Route path="/demo/ai-agent" element={<AiAgentDemoPage />} />
                <Route path="/api-keys" element={<ApiKeysPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/facebook-callback" element={<SocialCallback platform="facebook" />} />
                <Route path="/pinterest-callback" element={<SocialCallback platform="pinterest" />} />
                <Route path="/linkedin/callback" element={<SocialCallback platform="linkedin" />} />
                <Route path="/instagram-business/callback" element={<SocialCallback platform="instagram" />} />
                <Route path="/callback/discord" element={<SocialCallback platform="discord" />} />
                <Route path="/callback/github" element={<SocialCallback platform="github" />} />
                <Route path="/callback/telegram" element={<SocialCallback platform="telegram" />} />
                <Route path="/tiktok/callback" element={<SocialCallback platform="tiktok" />} />
                <Route path="/youtube/callback" element={<SocialCallback platform="youtube" />} />
                <Route path="/threads/callback" element={<SocialCallback platform="threads" />} />
                <Route path="/signin" element={
                  <div className="h-full flex items-center justify-center bg-white">
                    <div className="w-full max-w-md p-8 border rounded-2xl shadow-sm">
                      <AuthComponent onAuthSuccess={handleAuthSuccess} />
                    </div>
                  </div>
                } />
              </Routes>
            </main>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
